// extracted by mini-css-extract-plugin
export default {"checkboxGrid":"ContentfulCheckboxGroupInput-module__checkboxGrid--jgen5"};